// extracted by mini-css-extract-plugin
export var closeButton = "_q4-2";
export var closeButtonIcon = "_q4-3";
export var lightboxContent = "_q4-1";
export var lightboxOverlay = "_q4-0";